import React from "react";

const AddFavourites = () => {
    return (
        <>
            <span>Add Favourite ❤️</span> 
        </>
    )
}

export default AddFavourites